module.exports = __webpack_public_path__ + "img/arrow-left.56fc5751.svg";